import React from "react";
import { useNavigate } from "react-router-dom";

export default function RelatedProducts({ products, baseUrl }) {
  const navigate = useNavigate(); // ✅ navigation hook

  return (
    <div className="container mt-4 product-filter-page cursor-pointer">
      <div className="row">
        {products?.length > 0 ? (
          products?.map((product) => (
            <div
              key={product?.id}
              className="col-xs-4 col-lg-4 col-sm-6 col-md-4 mb-4 custom-product-card-colmn "
              onClick={() =>
                (window.location.href = `/product-details/${product?.slug}`)
              }
            >
              <div className="card product-card">
                <img
                  // src={img80}
                  src={`${baseUrl}/${product.image}`}
                  className="card-img-top"
                  alt={product?.title}
                  loading="lazy"

                  // onError={(e) => (e.target.src = "https://via.placeholder.com/150")} // Fallback image
                />
                <div className="card-body text-center">
                  <h5 className="card-title">{product.title}</h5>
                  <p className="card-text">{product.category_name}</p>
                  {/* <p className="card-text">{product.description}</p> */}
                  <button
                    onClick={() =>
                      navigate(`${`/product-details/${product?.slug}`}`)
                    }
                    className="w-full px-4 py-2 bg-[#003781]  rounded font-medium hover:bg-blue-700 transition-colors text-white"
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">No products found</div>
        )}
      </div>
    </div>
  );
}
